import "./general/general";
import "./blocks/about-box";
import "./blocks/team";
import "./blocks/showcase";
import GLightbox from "glightbox";
import { mainblock } from "./blocks/mainblock";

document.addEventListener("DOMContentLoaded", function (event) {
  mainblock();
   const lightbox = GLightbox({ selector: "._lightbox" });
});


